import { ArrowRight, Phone, Rocket, Cpu, BarChart3 } from 'lucide-react';
import Button from '../../ui/Button/Button.jsx';
import DeviceMockup from '../DeviceMockup/DeviceMockup.jsx';
import styles from './Hero.module.css';

const highlights = [
  {
    icon: Rocket,
    title: 'Future-Ready',
    text: 'Built with modern tech & scalable architecture.',
  },
  {
    icon: Cpu,
    title: 'AI-Powered',
    text: 'Intelligent systems that automate, analyze & adapt.',
  },
  {
    icon: BarChart3,
    title: 'Growth Driven',
    text: 'Digital products designed to scale your business.',
  },
];

export default function Hero() {
  return (
    <section className={styles.hero}>
      {/* Ambient background glow — purely decorative, no asset needed. */}
      <div className={styles.glowLeft} aria-hidden="true" />
      <div className={styles.glowRight} aria-hidden="true" />

      <div className={`container ${styles.grid}`}>
        <div className={styles.copy}>
          <span className={styles.eyebrow}>
            <span className={styles.eyebrowDash} aria-hidden="true" />
            Digital Solutions Studio
          </span>

          <h1 className={styles.title}>
            <span className={styles.line}>Your Vision.</span>
            <span className={`${styles.line} ${styles.lineGradient}`}>Intelligent Solutions.</span>
            <span className={styles.line}>Real Impact.</span>
          </h1>

          <p className={styles.subtitle}>
            We build digital products powered by AI that drive growth, simplify work,
            and create the future.
          </p>

          <div className={styles.actions}>
            <Button to="/solutions" size="lg">
              Explore Our Work <ArrowRight size={18} />
            </Button>
            <Button to="/contact" variant="secondary" size="lg">
              Book a Free Call <Phone size={16} />
            </Button>
          </div>

          <div className={styles.highlights}>
            {highlights.map((h) => (
              <div key={h.title} className={styles.highlight}>
                <span className={styles.highlightIcon}>
                  <h.icon size={20} strokeWidth={1.8} />
                </span>
                <div>
                  <span className={styles.highlightTitle}>{h.title}</span>
                  <p className={styles.highlightText}>{h.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className={styles.visual}>
          <DeviceMockup />
        </div>
      </div>
    </section>
  );
}
